import { Component } from '@angular/core';

@Component({
  selector: 'app-equalizeranimation',
  templateUrl: './equalizerAnimation.component.html',
  styleUrls: ['./equalizerAnimation.componant.scss'],
})

export class EqualizerAnimationComponent {
  bars = new Array(3);
  constructor() {
  }
}